import { gql } from '@apollo/client';

export const FiscalYearFragment = gql`
  fragment FiscalYear on FiscalYear {
    id
    year
    taxYearStartDate
    taxYearEndDate
    productType
    enabledDatetime
  }
`;
